<template>
  <div class="container">
    <p class="title">Wann sind witzige Daten?</p>
    <div class="columns">
      <div class="column is-flex">
        <b-table
          paginated
          per-page="10"
          pagination-position="top"
          :data="dateList"
          striped
          hoverable
          focusable
        >
          <template slot-scope="props">
            <b-table-column field="date" label="Wann?">
              <article class="media">
                <figure class="media-left is-hidden-mobile">
                  <span class="mdi mdi-alarm-check mdi-36px"></span>
                </figure>
                <div class="media-content">
                  <strong>{{ dateToString(props.row.date) }}</strong>
                  <div
                    class="content"
                    v-if="isTimeNeeded(props.row)"
                  >{{ timeToString(props.row.date) }}</div>
                </div>
              </article>
            </b-table-column>
            <b-table-column field="entries" label="Was?">
              <p v-for="item in props.row.entries" v-bind:key="item.literal">{{ item.literal }}</p>
            </b-table-column>
          </template>
        </b-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Alter",
  data() {
    return {
      birthday: 1558975560000,
      dateList: [],
      stopInYear: new Date().getFullYear() + 20
    };
  },
  mounted() {
    let intermediateDateList = [];
    Array.prototype.push.apply(
      intermediateDateList,
      this.loopSchnapszahlen(this.printMinutes)
    );
    Array.prototype.push.apply(
      intermediateDateList,
      this.loopRound(this.printMinutes)
    );
    Array.prototype.push.apply(
      intermediateDateList,
      this.loopSchnapszahlen(this.printHours)
    );
    Array.prototype.push.apply(
      intermediateDateList,
      this.loopRound(this.printHours)
    );
    Array.prototype.push.apply(
      intermediateDateList,
      this.loopSchnapszahlen(this.printDays)
    );
    Array.prototype.push.apply(
      intermediateDateList,
      this.loopRound(this.printDays)
    );
    Array.prototype.push.apply(
      intermediateDateList,
      this.loopSchnapszahlen(this.printWeeks)
    );
    Array.prototype.push.apply(
      intermediateDateList,
      this.loopRound(this.printWeeks)
    );

    let filterDate = new Date();
    filterDate.setDate(filterDate.getDate() - 1);

    intermediateDateList = intermediateDateList
      .filter(e => e.date > filterDate)
      .reduce(function(acc, obj) {
        var key = obj["date"];
        if (!acc[key]) {
          acc[key] = [];
        }
        acc[key].push(obj.description);
        return acc;
      }, []);

    intermediateDateList = Object.keys(intermediateDateList)
      .map(e => {
        return {
          date: new Date(e),
          entries: intermediateDateList[e]
        };
      })
      .sort((a, b) => a.date - b.date);

    this.dateList = intermediateDateList;
  },
  methods: {
    printMinutes: function(counter) {
      let additionalMinutes = counter * 1000 * 60;
      let tempdate = new Date(additionalMinutes + this.birthday);
      return {
        date: tempdate,
        description: {
          literal: new Intl.NumberFormat().format(counter) + " Minuten",
          granularity: "minutes"
        }
      };
    },
    printHours: function(counter) {
      let additionalMinutes = counter * 1000 * 60 * 60;
      let tempdate = new Date(additionalMinutes + this.birthday);
      return {
        date: tempdate,
        description: {
          literal: new Intl.NumberFormat().format(counter) + " Stunden",
          granularity: "hours"
        }
      };
    },
    printDays: function(counter) {
      let additionalMinutes = counter * 1000 * 60 * 60 * 24;
      let tempdate = new Date(additionalMinutes + this.birthday);
      return {
        date: tempdate,
        description: {
          literal: new Intl.NumberFormat().format(counter) + " Tage",
          granularity: "days"
        }
      };
    },
    printWeeks: function(counter) {
      let additionalMinutes = counter * 1000 * 60 * 60 * 24 * 7;
      let tempdate = new Date(additionalMinutes + this.birthday);
      return {
        date: tempdate,
        description: {
          literal: new Intl.NumberFormat().format(counter) + " Wochen",
          granularity: "weeks"
        }
      };
    },
    loopSchnapszahlen: function(callback) {
      let intermediateDateList = [];
      let prev = 1;
      for (let i = 10; ; i = i * 10) {
        prev = prev + i;
        for (let j = 1; j < 10; j++) {
          let result = callback(j * prev);
          if (result.date.getFullYear() > this.stopInYear) {
            return intermediateDateList;
          }
          intermediateDateList.push(result);
        }
      }
    },
    loopRound: function(callback) {
      let intermediateDateList = [];
      for (let i = 10; ; i = i * 10) {
        for (let j = 1; j < 10; j++) {
          let result = callback(i * j);
          if (result.date.getFullYear() > this.stopInYear) {
            return intermediateDateList;
          }
          intermediateDateList.push(result);
        }
      }
    },
    dateToString: function(date) {
      const options = {
        day: "2-digit",
        month: "long",
        year: "numeric",
        timeZone: "Europe/Berlin"
      };
      return date.toLocaleString("de-DE", options);
    },
    timeToString: function(date) {
      const options = {
        hour: "numeric",
        minute: "numeric",
        timeZone: "Europe/Berlin"
      };
      return date.toLocaleString("de-DE", options);
    },
    isTimeNeeded(obj) {
      for (let i = 0; i < obj.entries.length; i++) {
        let entry = obj.entries[i];
        if (entry.granularity === "minutes" || entry.granularity === "hours") {
          return true;
        }
      }
      return false;
    }
  }
};
</script>